import * as actionTypes from "../actionTypes/actionTypes";

const initialState = {
  drawingRules: {
    data: [],
    isLoading: false,
    hasError: false,
  },
  layers: {
    data: [],
    isLoading: false,
    hasError: false,
  },
  createRule: {
    data: {},
    isLoading: false,
    hasError: false,
  },
  deleteRule: {
    data: {},
    isLoading: false,
    hasError: false,
  },
  updateRules: {
    data: {},
    isLoading: false,
    hasError: false,
  },
  newRule: {
    data: {},
    isLoading: false,
    hasError: false,
  },
  deleteDrawingRule: {
    data: {},
    isLoading: false,
    hasError: false,
  },
};

const checkLayerDependencies = (data) => {
  let isPresent = false;
  for (let layer of data) {
    if (layer?.layerDependencies && layer?.layerDependencies?.length > 0) {
      isPresent = true;
      break;
    }
  }
  return isPresent;
};

export const rulesReducer = (state = initialState, action) => {
  const newState = { ...state };
  switch (action.type) {
    case actionTypes.GET_DRAWING_RULES:
      return {
        ...newState,
        drawingRules: {
          ...newState.drawingRules,
          isLoading: true,
          hasError: false,
        },
      };
    case actionTypes.GET_DRAWING_RULES_SUCCESS:
      action.payload.layers &&
        action.payload.layers.length > 0 &&
        action.payload.layers.forEach((element) => {
          const layerDependencies = checkLayerDependencies(element?.layerRules);
          element.alwaysOn =
            element?.alwaysOn === 0 || layerDependencies ? false : true;
          element.removeForDxf = element?.removeForDxf === 0 ? false : true;
          element.isCompareFullName =
            element?.isCompareFullName == null ||
            !element?.isCompareFullName ||
            element?.isCompareFullName === 0
              ? false
              : true;
          element["alwaysOff"] =
            element?.alwaysOn || layerDependencies ? false : true;
          element["disabled"] =
            !element?.alwaysOff || layerDependencies ? false : true;
          element["isDelete"] = false;
          element["isAdd"] = false;
        });
      return {
        ...newState,
        drawingRules: {
          data: action.payload,
          isLoading: false,
          hasError: false,
        },
      };
    case actionTypes.GET_DRAWING_LAYER_SUCCESS:
      action.payload.layers &&
        action.payload.layers.length > 0 &&
        action.payload.layers.forEach((element) => {
          const layerDependencies = checkLayerDependencies(element?.layerRules);
          // element.alwaysOn = element?.alwaysOn ==  "-1" || !layerDependencies ? true : false;
          element.alwaysOn = element?.alwaysOn == "-1" ? true : false;
          element.removeForDxf = element?.removeForDxf === 0 ? false : true;
          element.isCompareFullName =
            element?.isCompareFullName == null ||
            !element?.isCompareFullName ||
            element?.isCompareFullName === 0
              ? false
              : true;
          element["alwaysOff"] = false;
          element["disabled"] =
            !element?.alwaysOff || layerDependencies ? false : true;
          element["isDelete"] = false;
          element["isAdd"] = false;
        });
      //  console.log(action.payload)
      return {
        ...newState,
        layers: { data: action.payload, isLoading: false, hasError: false },
      };
    case actionTypes.GET_DRAWING_RULES_FAILURE:
      return {
        ...newState,
        drawingRules: {
          data: action.payload,
          isLoading: false,
          hasError: true,
        },
      };
    case actionTypes.GET_RULES:
      return {
        ...newState,
        rules: { ...newState.rules, isLoading: true, hasError: false },
      };
    case actionTypes.GET_RULES_SUCCESS:
      return {
        ...newState,
        rules: { data: action.payload, isLoading: false, hasError: false },
      };
    case actionTypes.GET_RULES_FAILURE:
      return {
        ...newState,
        rules: { data: action.payload, isLoading: false, hasError: true },
      };
    case actionTypes.CREATE_RULE:
      return {
        ...newState,
        createRule: {
          ...newState.createRule,
          isLoading: true,
          hasError: false,
        },
      };
    case actionTypes.CREATE_RULE_SUCCESS:
      return {
        ...newState,
        createRule: { data: action.payload, isLoading: false, hasError: false },
      };
    case actionTypes.CREATE_RULE_FAILURE:
      return {
        ...newState,
        createRule: { data: action.payload, isLoading: false, hasError: true },
      };

    case actionTypes.NEW_RULE:
      return {
        ...newState,
        newRule: { ...newState.newRule, isLoading: true, hasError: false },
      };
    case actionTypes.NEW_RULE_SUCCESS:
      return {
        ...newState,
        newRule: { data: action.payload, isLoading: false, hasError: false },
      };
    case actionTypes.NEW_RULE_FAILURE:
      return {
        ...newState,
        newRule: { data: action.payload, isLoading: false, hasError: true },
      };

    case actionTypes.DELETE_DRAWING_RULE:
      return {
        ...newState,
        deleteRule: {
          ...newState.deleteRule,
          isLoading: true,
          hasError: false,
        },
      };
    case actionTypes.DELETE_DRAWING_RULE_SUCCESS:
      return {
        ...newState,
        deleteRule: { data: action.payload, isLoading: false, hasError: false },
      };
    case actionTypes.DELETE_DRAWING_RULE_FAILURE:
      return {
        ...newState,
        deleteRule: { data: action.payload, isLoading: false, hasError: true },
      };

    case actionTypes.DELETE_RULE:
      return {
        ...newState,
        deleteDrawingRule: {
          ...newState.deleteDrawingRule,
          isLoading: true,
          hasError: false,
        },
      };
    case actionTypes.DELETE_RULE_SUCCESS:
      return {
        ...newState,
        deleteDrawingRule: {
          data: action.payload,
          isLoading: false,
          hasError: false,
        },
      };
    case actionTypes.DELETE_RULE_FAILURE:
      return {
        ...newState,
        deleteDrawingRule: {
          data: action.payload,
          isLoading: false,
          hasError: true,
        },
      };

    case actionTypes.UPDATE_RULE:
      return {
        ...newState,
        updateRules: {
          ...newState.updateRules,
          isLoading: true,
          hasError: false,
        },
      };
    case actionTypes.UPDATE_RULE_SUCCESS:
      return {
        ...newState,
        updateRules: {
          data: action.payload,
          isLoading: false,
          hasError: false,
        },
      };
    case actionTypes.UPDATE_RULE_FAILURE:
      return {
        ...newState,
        updateRules: { data: action.payload, isLoading: false, hasError: true },
      };

    default:
      return { ...newState };
  }
};
